export const SFX_ONE_SHOT_EVENT = 'nova:sfxoneshot'
export const SFX_LOOP_VISIBILITY_EVENT = 'nova:sfxloopvisibility'
export const SFX_SIGNAL_VISIBILITY_EVENT = 'nova:sfxsignalvisibility'
export const SFX_SIGNAL_PULSE_EVENT = 'nova:sfxsignalpulse'

export type SfxOneShotDetail = {
  src: string
  volume?: number
  playbackRate?: number
}

export type SfxLoopVisibilityDetail = {
  id: string
  src: string
  visible: boolean
  volume?: number
  fadeInMs?: number
  fadeOutMs?: number
}

export type SfxSignalVisibilityDetail = {
  visible: boolean
  durationMs: number
}

export type SfxSignalPulseDetail = {
  intensity: number
}

export const dispatchSfxOneShot = (
  target: EventTarget,
  detail: SfxOneShotDetail,
) =>
  target.dispatchEvent(
    new CustomEvent<SfxOneShotDetail>(SFX_ONE_SHOT_EVENT, {
      detail,
      bubbles: true,
    }),
  )

export const dispatchSfxLoopVisibility = (
  target: EventTarget,
  detail: SfxLoopVisibilityDetail,
) =>
  target.dispatchEvent(
    new CustomEvent<SfxLoopVisibilityDetail>(SFX_LOOP_VISIBILITY_EVENT, {
      detail,
      bubbles: true,
    }),
  )

export const dispatchSfxSignalVisibility = (
  target: EventTarget,
  detail: SfxSignalVisibilityDetail,
) =>
  target.dispatchEvent(
    new CustomEvent<SfxSignalVisibilityDetail>(SFX_SIGNAL_VISIBILITY_EVENT, {
      detail,
      bubbles: true,
    }),
  )

export const dispatchSfxSignalPulse = (
  target: EventTarget,
  detail: SfxSignalPulseDetail,
) =>
  target.dispatchEvent(
    new CustomEvent<SfxSignalPulseDetail>(SFX_SIGNAL_PULSE_EVENT, {
      detail,
      bubbles: true,
    }),
  )
